
import React from 'react'

import { useAuth } from '@/Hooks/UseAuth'
import { usePlan } from '@/Hooks/UsePlan'
import { useProject } from '@/Hooks/UseProject'
import { useTeams } from '@/Hooks/UseTeam'
import useTranslation from '@/Hooks/UseTranslation'

import './ButtonAddMember.scss'

interface Props {
  className?: string
}

const ButtonAddMember = ({ className }: Props) => {

  const { t } = useTranslation()

  const { userData } = useAuth()

  const { project } = useProject()

  const { setShowTeamMembersSelector } = useTeams()

  const { plan, showTooManyObserversModal } = usePlan()

  const handleAddPressed = () => {

    if (plan.can('add', 'Observer')) {

      setShowTeamMembersSelector(true)
    } else {

      showTooManyObserversModal(t('TEAMS:CantAddMoreObservers'), project.user === userData?.id)
    }
  }

  return (
    <button
      className="btn btn-add-member"
      onClick={handleAddPressed}
    >
      <span className="icon-agregar_colaborador"></span>
      <span className="button-text">
        {' ' + t('TEAMS:ToolbarAddTeamMemberButton')}
      </span>
    </button>
  )
}

export default ButtonAddMember
